module.exports = __webpack_public_path__ + "fonts/Noto_Sans_JP-400-95.3987bea.woff2";